import { environment } from '../../environments/environment';

export const baseAPI = `${environment.baseUrl}/api/v1`;

export const publicFileURL = baseAPI + '/public/file'
export const personaApiURL = baseAPI + '/personas';
export const hierarchyApiURL = baseAPI + '/hierarchy';
export const personasProfileCompanyApiURL = baseAPI + '/sections/profile/subsections/company';
export const personaCompanyApiURL = '/sections/profile/subsections/company';
export const personaPersonalApiURL = '/sections/profile/subsections/personal';
export const workingHoursPersonalApiURL = '/sections/profile/subsections/workinghours';
export const personaPersonalLovApiURL = '/sections/profile/subsections/personal/lov';
export const personaCompanyLovApiURL = '/sections/profile/subsections/company/lov';
export const profilePersonalExtraTypeURL = '/sections/profile/subsections/personal/extras';
export const profileCompanyExtraTypeURL = '/sections/profile/subsections/company/extras';

// relationship
export const personaRelationshipEmployessApiURL = '/sections/relationship/subsections/employee';
export const personaRelationshipSuppliersApiURL = '/sections/relationship/subsections/supplier';

// finance
export const personaFinanceGeneralApiURL = '/sections/finance/subsections/general';
export const personaFinanceCostsApiURL = '/sections/finance/subsections/cost';
// operations
export const personaOperationsGeneralApiURL = '/sections/operations/subsections/general';
export const personaOperationsOrganizationChartApiURL = '/sections/operations/subsections/organizationchart';
export const personaOperationsDomainApiURL = '/sections/operations/subsections/domain';
export const personaOperationsKpiApiURL = '/sections/operations/subsections/kpi';
// variable compensation
export const personaVariableCompensationGeneralApiURL = '/sections/variablecompensation/subsections/general';
// certificates
export const personaCertificatesGeneralApiURL = '/sections/certification/subsections/general';
export const personaCertificatesAchievementApiURL = '/sections/certification/subsections/achievement';
// accounts
export const personaAccountGeneralApiURL = '/sections/account/subsections/general';
// gdpr
export const personaGdprPdpaApiURL = '/sections/gdpr/subsections/personaldataprocessingauthorization';
export const personaGdprSadApiURL = '/sections/gdpr/subsections/systemadministratordesignation';
//identification
export const personaIdentificationGeneralApiURL = '/sections/identification/subsections/general';
// equipment
export const personaEquipmentApiURL = '/sections/equipment/subsections';

export const userApiURL = baseAPI + '/users';

//maintence 
export const maintenceURl = baseAPI + '/maintenance';

//options 
export const optionsAPI = baseAPI + '/options';

// reports 
export const reports = baseAPI + '/reports';
export const allReportsForLoggedUser = baseAPI + '/reports';

// admin reports
export const adminReports = baseAPI + '/reports/admin';
export const adminAllReports = baseAPI + '/reports/admin';
export const adminReportAllUsers = baseAPI + '/reports/admin/lov/users';


